import Vue from 'vue'
import Vuex from 'vuex'

import getters from './getters'
import actions from './actions'
import mutations from './mutations'

Vue.use(Vuex)

if (!window.siteheader) {
  window.siteheader = {}
}

export default new Vuex.Store({
  state: {
    // ui
    header: window.siteheader || [],
    menuOpen: false,

    // content
    categories: window.siteheader.categories,
    tags: window.siteheader.tags,
    stickies: null,
    posts: null,
    totalPosts: null,
    totalPages: null,

    // current post
    post: null,
    expanded: null, // id

    // current page
    page: null,

    // nav
    from: null
  },
  getters,
  actions,
  mutations
})
